import React from "react";
import { io } from "socket.io-client";

// In development (localhost:3000), connect directly to backend server (localhost:80)
// to avoid WebSocket proxy conflicts with webpack-dev-server's /ws endpoint
// In production, use the current host (which will be the backend server)
const isDevelopment = window.location.hostname === 'localhost' && window.location.port === '3000';
const SERVER_URL = isDevelopment 
  ? 'http://localhost:80'
  : window.location.protocol + "//" + window.location.host;

export const socket = io.connect(SERVER_URL);

export const SocketContext = React.createContext(socket);